<div class="container">
    <div class="content">
        <div class="title-container">
            <!-- <img src="/images/TMOZ Logo - Centered - Reversed - NoHammer-NoTagline.png" alt="Travel Money OZ" /> -->
            <img src="/images/travlex_2017_new-01.png" alt="Travelex UK" />
            <!-- <div class="title-text-container">
                <span class="title-text">Flight Centre</span>
            </div> -->
        </div>
        <!-- <img class="img-style" src="../../../assets/pics/tmoz-logo.png" alt="Travel Money OZ" /> -->
        <div class="top-banner">
            <!-- <img src="../../../assets/DD-9257_Deals Page Header_desktop_1920x550.jpg" alt="Martin Garrix" /> -->
            <img src="/images/tvx-plus-hero-2.png" alt="Travelex UK" />
            <!-- <img src="../../../assets/pics/MIC_TMG_CBA_Currency-Pass-RTW-blog_1920x420_v1.jpg" alt="Travel Money OX" /> -->
            <!-- <div class="top-banner-curved-edge"></div> -->
        </div>
        <!-- <div class="top-banner-curved-edge-backgroud">
            <div class="top-banner-curved-edge"></div>
        </div> -->
        <div class="form-content">

            <div class="bc-panel-body-grid">
                <div class="bc-layout-grid">
                    @if(!registrationSuccess){
                        <!-- <div class="section-header">
                            <span class="section-header-text">Link your Travelex Plus ID</span>
                            <span>You are about to link your Travelex Plus ID to your card. </span>
                        </div> -->
                        <!-- <div style="display:flex; flex-direction: column; gap: 10px;">
                            <span>Enter your Travelex Plus ID below</span>
                            <mat-form-field>
                                <input matInput type="text" #firstname [formControl]="tvxIdControl" placeholder="Travelex Plus ID" maxLength="80">
                                <fa-icon matSuffix [icon]="['fas', 'address-card']" class="field-icon" [style]="{padding: '0px 20px 0px 0px'}" [fixedWidth]="true" size="lg"></fa-icon>
                                <mat-hint align="end">{{firstname.value.length}} / 10</mat-hint>
                                @if (tvxIdControl.invalid) {
                                    <mat-error>You must enter a valid Travelex Plus ID</mat-error>
                                }
                            </mat-form-field>
                        </div> -->

                        <div class="section-header">
                            <span class="section-header-text">Register for Travelex Plus!</span>
                            <span>Enter your details below to register. </span>
                        </div>
                        <div>
                        </div>
                        <div>
                            <span>Enter your first name</span>
                            <mat-form-field>
                                <input matInput type="text" #firstname [formControl]="firstnameControl" placeholder="John" maxLength="80">
                                <fa-icon matSuffix [icon]="['fas', 'user']" class="field-icon" [style]="{padding: '0px 20px 0px 0px'}" [fixedWidth]="true" size="lg"></fa-icon>
                                <mat-hint align="end">{{firstname.value.length}} / 80</mat-hint>
                                @if (firstnameControl.invalid) {
                                    <mat-error>You must enter a valid first name</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div>
                            <span>Enter your last name</span>s
                            <mat-form-field>
                                <!-- <mat-label>Email address</mat-label> -->
                                <input matInput type="text" #lastname [formControl]="lastnameControl" placeholder="Smith" maxLength="80">
                                <!-- <mat-icon matSuffix>person_add</mat-icon> -->
                                <fa-icon matSuffix [icon]="['fas', 'user-plus']" class="field-icon" [style]="{padding: '0px 20px 0px 0px'}" [fixedWidth]="true" size="lg"></fa-icon>
                                <mat-hint align="end">{{lastname.value.length}} / 80</mat-hint>
                                @if (lastnameControl.invalid) {
                                    <mat-error>You must enter a valid last name</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div>
                            <span>Enter your email address</span>
                            <mat-form-field>
                                <!-- <mat-label>Email address</mat-label> -->
                                <input matInput type="email" [formControl]="emailControl" placeholder="john.smith@example.com">
                                <!-- <mat-icon matSuffix>email</mat-icon> -->
                                <fa-icon matSuffix [icon]="['fas', 'envelope']" class="field-icon" [style]="{padding: '0px 20px 0px 0px'}" [fixedWidth]="true" size="lg"></fa-icon>
                                @if (emailControl.invalid) {
                                    <mat-error>You must enter a valid email address</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        <div>
                            <span>Enter your phone number</span>
                            <mat-form-field>
                                <mat-label>Phone number</mat-label>
                                <span matTextPrefix>+44 &nbsp;</span>
                                <input matInput type="tel" [formControl]="phoneControl" placeholder="12345678" maxLength="10">
                                <!-- <mat-icon matSuffix>call</mat-icon> -->
                                <fa-icon matSuffix [icon]="['fas', 'phone']" class="field-icon" [style]="{padding: '0px 20px 0px 0px'}" [fixedWidth]="true" size="lg"></fa-icon>
                                @if (phoneControl.invalid) {
                                    <mat-error>You must enter a valid phone number</mat-error>
                                }
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-checkbox class="example-margin" [formControl]="tcControl">
                                I have read and agreed to the <a href="https://www.travelex.co.uk/offers/travelex-plus-terms-and-conditions" target="_blank">Terms
                                    and Conditions</a>
                            </mat-checkbox>
                        </div>

                        
                        <div class="pay-container">
                            <button class="pay-btn" mat-raised-button color="custom-color" [class.spinner]="registerLoading"
                            [disabled]="this.firstnameControl.invalid || this.lastnameControl.invalid || this.emailControl.invalid || this.phoneControl.invalid || tcControl.invalid"
                                (click)="register()">
                                Register
                            </button>
                        </div>
                    }
                    @else{
                        <!-- <div class="section-header-success">
                            <span class="section-header-text-success">Registration Successful</span>
                        </div> -->
                        <div class="success-message">
                            
                            <span class="section-header-text-success">Registration Successful</span>
                            <p class="text-message">Below is your Travelex Plus detail.</p>

                            <div class="order-data">
                                <span class="order-data-title">Travelex Plus</span>
                                <span class="order-data-text">{{tvxPlusId()}}</span>
                                <qrcode class="qr-data" [qrdata]=tvxPlusId() [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
                            </div>

                            <p class="text-message">You can now proceed with your ATM transaction</p>
                        </div>
                    }

                </div>
            </div>

        </div>
    </div>
</div>